const descriptions = {
  0: { text: 'Moteur de recherche de formations' },
  1: { text: 'Offres de stage' },
  2: { text: 'Offres d’emploi et d’alternance' },
  3: { text: 'Gestion des candidatures' },
  4: { text: 'Gestion des projets de recrutement' },
  5: { text: '60 contacts de la CVthèque / mois', color: 'blue' },
  6: { text: '240 contacts de la CVthèque / mois', color: 'blue' },
  7: { text: 'Accès à la CVthèque', color: 'blue' },
  8: { text: 'Accompagnement personnalisé' },
  9: { text: 'Sourcing de candidats auprès des écoles' },
}

const generateDescription = (descriptionChecked, includedIndices) => {
  return includedIndices.map((index, i) => {
    const { text, color } = descriptions[index];
    return {
      description: text,
      status: descriptionChecked[i],
      indexDescription: index,
      color: color || (descriptionChecked[i] ? 'green' : 'red')
    };
  });
};


const indicesDescriptionFreemium = [0, 1, 2, 3, 4, 5, 8, 9];
const indicesDescriptionCasual = [0, 1, 2, 3, 4, 5, 8, 9];
const indicesDescriptionRegular = [0, 1, 2, 3, 4, 6, 8, 9];
const indicesDescriptionMajorAccount = [0, 1, 2, 3, 4, 7, 8, 9];

const DescriptionFreemium = generateDescription([true, true, true, true, true, false, false, false], indicesDescriptionFreemium);
const DescriptionCasual = generateDescription([true, true, true, true, true, true, false, false], indicesDescriptionCasual);
const DescriptionRegular = generateDescription([true, true, true, true, true, true, true, false], indicesDescriptionRegular);
const DescriptionMajorAccount = generateDescription([true, true, true, true, true, true, true, true], indicesDescriptionMajorAccount);

export { DescriptionFreemium, DescriptionCasual, DescriptionRegular, DescriptionMajorAccount };